import { Component, OnInit } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { ScrollEvent } from 'ngx-scroll-event';
import { Circle } from '../../../core/models/circle.model';

@Component({
    selector: 'app-modal-events',
    templateUrl: './modal-events.component.html',
    styleUrls: ['./modal-events.component.scss']
})
export class ModalEventsComponent implements OnInit {

    public circle: Circle = null;
    public scrollEvent: ScrollEvent;

    constructor(public bsModalRef: BsModalRef) { }

    ngOnInit() {
    }

    loadData(event: ScrollEvent) {
        this.scrollEvent = event;
    }

}
